export const DEFAULT_OFFSET = 1
export const LAST_OFFSET = 0
export const DEFAULT_LIMITS = 15
export const MAX_LIMITS = 30
export const BIG_NUMBER_DECIMAL = 40
